module.exports = __webpack_public_path__ + "static/media/icon8.e78bf694.svg";